/* import __COLOCATED_TEMPLATE__ from './api-setup-sidedrawer.hbs'; */
/* RESPONSIBLE TEAM: team-rd-services */

import templateOnlyComponent from '@ember/component/template-only';
import type LivePersonConfiguration from 'embercom/models/standalone/live-person-configuration';

export interface Args {
  isOpen: boolean;
  onClose: () => void;
  closeOnSave: () => void;
  livePersonConfig: LivePersonConfiguration;
}

const StandaloneLivePersonApiSetupSidedrawer = templateOnlyComponent<Args>();
export default StandaloneLivePersonApiSetupSidedrawer;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::LivePerson::ApiSetupSidedrawer': typeof StandaloneLivePersonApiSetupSidedrawer;
    'standalone/live-person/api-setup-sidedrawer': typeof StandaloneLivePersonApiSetupSidedrawer;
  }
}
